import React, {useState, useEffect} from 'react'
import axios from '../../api/axios';
import toast from 'react-hot-toast';
import { logoStorage_LINK, CategorylogoStorage_LINK, PIN_TASK_COUNT } from '../../api/ApiUrl';

import {NavLink} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { UserCircle, Settings, Add, CheckDone, Bell, Work, Pin, ChevronLeft, ChevronRight, Drag, Chart } from './Icons';
import Logo from '../../Logo'
import Avatar from './Avatar';

import { onSnapshot, query, where, collection, doc, updateDoc, orderBy, limit, startAfter, getDocs, writeBatch } from "firebase/firestore";
import {db} from '../../config/firebaseConfig'
import NotificationPanel from './NotificationPanel';
import NotificationCircle from './NotificationCircle';
import { setPinnedCount } from '../../features/taskMeta';

const SideNav = () => {
    const companies=useSelector((state)=>state.company.value);
    const categs=useSelector((state)=>state.category.value)
    const user=useSelector((state)=>state.user.value);
    const pinnedTaskCount=useSelector((state)=>state.taskMeta.pinnedCount);
    const dispatch=useDispatch();
  const [showNotification, setShowNotification]=useState(false);


const [notifications, setNotifications]=useState([]);
const [lastKey, setLastKey]=useState()
const [isEmpty, setIsEmpty]=useState(false);
const [load, setLoad]=useState(true);
const [EndData, setEndData]=useState(false);

const [ unread, setUnread]=useState(0);
const [sidebarCollapsed, setSidebarCollapsed]=useState(()=>localStorage.getItem('escapeLeftSidebarCollapsed') === 'true');
const [draggingCategory, setDraggingCategory]=useState(null);
const [categoryOrder, setCategoryOrder]=useState(()=>{
  try{
    return JSON.parse(localStorage.getItem('escapeCategorySidebarOrder') || '{}');
  }catch(e){
    return {};
  }
});

    const q=query(collection(db, "Notifications"), where("receiverId", "==", user.id), orderBy("createdAt", "desc"), limit(20))
    

    useEffect(()=>{
      const listenNotification=onSnapshot(q, (snapShot)=>{
        if(snapShot.size>0){
          const data=snapShot.docs.map(doc=>{return {...doc.data(), id: doc.id} })
          setNotifications(data)
          const last=snapShot.docs[snapShot.docs.length-1]
          setLastKey(last)
          setLoad(false)
          const countUnread=data.filter(d=>d.read==false).length
          setUnread(countUnread);
          setEndData(false)
        }else{
          setIsEmpty(true) 
        }
      })
      return ()=>{
        listenNotification()
        setLastKey()
        setIsEmpty(false)
        setEndData(false)
        setNotifications([])
      }
    },[])

    useEffect(()=>{
      document.body.classList.toggle('left-sidebar-collapsed', sidebarCollapsed);
      localStorage.setItem('escapeLeftSidebarCollapsed', sidebarCollapsed ? 'true' : 'false');
      return()=>document.body.classList.remove('left-sidebar-collapsed');
    },[sidebarCollapsed])


    const getOrderedCategories=(companyId)=>{
      const companyCategories=categs.filter((cat)=>cat.companyId==companyId);
      const order=categoryOrder[companyId] || [];

      return [...companyCategories].sort((a,b)=>{
        const aIndex=order.indexOf(a.id);
        const bIndex=order.indexOf(b.id);
        const normalizedA=aIndex === -1 ? order.length + companyCategories.findIndex((cat)=>cat.id===a.id) : aIndex;
        const normalizedB=bIndex === -1 ? order.length + companyCategories.findIndex((cat)=>cat.id===b.id) : bIndex;
        return normalizedA - normalizedB;
      })
    }

    const reorderCategory=(companyId, sourceCategoryId, targetCategoryId)=>{
      const orderedIds=getOrderedCategories(companyId).map((cat)=>cat.id);
      const currentIndex=orderedIds.indexOf(sourceCategoryId);
      const nextIndex=orderedIds.indexOf(targetCategoryId);

      if(currentIndex < 0 || nextIndex < 0 || currentIndex === nextIndex){
        return;
      }

      const nextOrder=[...orderedIds];
      const [moved]=nextOrder.splice(currentIndex, 1);
      nextOrder.splice(nextIndex, 0, moved);

      const nextState={
        ...categoryOrder,
        [companyId]: nextOrder,
      };

      setCategoryOrder(nextState);
      localStorage.setItem('escapeCategorySidebarOrder', JSON.stringify(nextState));
    }

    const handleCategoryDragStart=(event, companyId, categoryId)=>{
      setDraggingCategory({companyId, categoryId});
      event.dataTransfer.effectAllowed='move';
      event.dataTransfer.setData('text/plain', `${companyId}:${categoryId}`);
    }

    const handleCategoryDrop=(event, companyId, targetCategoryId)=>{
      event.preventDefault();
      const dragData=draggingCategory;
      setDraggingCategory(null);

      if(!dragData || dragData.companyId!==companyId){
        return;
      }

      reorderCategory(companyId, dragData.categoryId, targetCategoryId);
    }


    useEffect(()=>{
      if(!user?.id){
        dispatch(setPinnedCount(0));
        return;
      }

      let mounted=true;
      const fetchPinnedCount=async()=>{
        try{
          const res=await axios.get(`${PIN_TASK_COUNT}${user.id}`);
          if(mounted){
            dispatch(setPinnedCount(res.data.pinnedCount));
          }
        }catch(e){
          console.log(e);
        }
      }

      fetchPinnedCount();
      return()=>{ mounted=false; }
    },[user?.id, dispatch])


    const loadMoreNotification=(snapShot)=>{
      const noData=snapShot.size===0;
      if(!noData){
        const data=snapShot.docs.map(doc=>{return {...doc.data(), id: doc.id} })
        const last=snapShot.docs[snapShot.docs.length-1]
        setNotifications((showNotification)=>[...showNotification, ...data])
        setLastKey(last)
      }else{
        setEndData(true)
      }
      setLoad(false);
    }


    const fetchmoreNotification=async()=>{
      const q=query(collection(db, "Notifications"), where("receiverId", "==", user.id), orderBy("createdAt", "desc"), startAfter(lastKey), limit(10))
      setLoad(true);
      const allNotifications = await getDocs(q);
      loadMoreNotification(allNotifications)
    
    }


  return (
    <>
    <div className={`app-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className='app-sidebar-brand'>
          <div className='app-brand-mark'>
            <Logo className='w-7 h-7' fill={"fill-white"} />
          </div>
          <div className='min-w-0'>
            <p className='app-brand-name'>EscapeTask</p>
          </div>
          <button
            type='button'
            className='app-sidebar-collapse-btn'
            onClick={()=>setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed?
              <ChevronRight iconClass={'w-4 h-4'}/>
              :
              <ChevronLeft iconClass={'w-4 h-4'}/>
            }
          </button>
        </div>

        <div className='app-sidebar-scroll no-scrollbar'>
          <p className='app-sidebar-section'>Main</p>
          <NavLink to='/myTasks' className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <Work iconClass={'w-5 h-5'}/>
            <span>Tasks</span>
          </NavLink>
          <NavLink to='/doneTasks' className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <CheckDone iconClass={'w-5 h-5'}/>
            <span>Completed</span>
          </NavLink>
          <NavLink to='/analytics' className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <Chart iconClass={'w-5 h-5'}/>
            <span>Analytics</span>
          </NavLink>
          <button onClick={()=>{setShowNotification(!showNotification)}} className={`app-nav-link relative w-full ${showNotification? `active` : ``}`}>
            <Bell iconClass={'w-5 h-5'}/>
            <span>Notifications</span>
            <NotificationCircle value={unread}/>
          </button>

          <p className='app-sidebar-section'>Pinned</p>
          <NavLink to='/pinnedTasks' className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <Pin iconClass={'w-5 h-5'}/>
            <span>Pinned Tasks</span>
            {pinnedTaskCount>0?
            <span className='app-nav-red-counter'>{pinnedTaskCount}</span>
            :
            null}
          </NavLink>

          <p className='app-sidebar-section'>Workspaces</p>
          {companies.map((co)=>
          <div className='app-workspace-group' key={co.id}>
            <NavLink to={`/company/${co.id}`} title={co.name} className={({isActive})=>`app-company-link ${isActive ? 'active' : ''}`}>
              <SidebarIcon icon={co.logo} isVariable={true} text={co.name}/>
              <span className='truncate'>{co.name}</span>
            </NavLink>

            <div className='app-category-list'>
            {getOrderedCategories(co.id).map((cat)=>(
              <div
                className={`app-category-row ${draggingCategory?.categoryId===cat.id ? 'dragging' : ''}`}
                key={cat.id}
                draggable
                onDragStart={(event)=>handleCategoryDragStart(event, co.id, cat.id)}
                onDragOver={(event)=>event.preventDefault()}
                onDrop={(event)=>handleCategoryDrop(event, co.id, cat.id)}
                onDragEnd={()=>setDraggingCategory(null)}
              >
                <span className='app-category-drag-handle' title='Drag to sort'>
                  <Drag iconClass={'w-3.5 h-3.5'}/>
                </span>
                <NavLink title={cat.name} to={`/category/${co.id}/${cat.id}`} className={({isActive})=>`app-category-link ${isActive ? 'active' : ''}`}>
                  <SidebarIcon icon={cat.icon} isVariable={true} isCateg={true} text={cat.name}/>
                  <span className='truncate'>{cat.name}</span>
                </NavLink>
              </div>
              ))}
            </div>
          </div>
          )
          }
          {companies.length>0?
          <NavLink to="/create/category" className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <Add iconClass={'w-5 h-5'}/>
            <span>Add Category</span>
          </NavLink>
          :
          null
          }
        </div>

        <div className='app-sidebar-footer'>
          <NavLink to="/profile" className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}> 
            <UserCircle iconClass={'w-5 h-5'}/>
            <span>Profile</span>
          </NavLink>
          <NavLink to="/settings" className={({isActive})=>`app-nav-link ${isActive ? 'active' : ''}`}>
            <Settings iconClass={'w-5 h-5'}/>
            <span>Settings</span>
          </NavLink>
        </div>
    </div>

    {showNotification &&
        <NotificationPanel 
        notifications={notifications} 
        fetchmoreNotification={fetchmoreNotification} 
        load={load} 
        setLoad={setLoad}
        isEmpty={isEmpty} 
        EndData={EndData}
        setShowNotification={setShowNotification}
        />
        }
    </>
  )
}

const SidebarIcon = ({icon, text, isVariable, clickFunction, isCateg}) => (
    <div className='app-nav-avatar group' onClick={clickFunction}>
        {isVariable?
        <>
         {icon?
          <>
          {isCateg?
          <img src={`${CategorylogoStorage_LINK}${icon}`} className='object-cover w-6 h-6 rounded-md avatar'/>
          :
          <img src={`${logoStorage_LINK}${icon}`} className='object-cover w-6 h-6 rounded-md avatar'/>
          }
          </>   
            :
          <Avatar value={text} width='6' height='6' color={'bg-slate-100 dark:bg-slate-700'} />   

        }
        </>
        :
        <>
        {icon}
        </>
        }
    {/* <span className='sidebar-tooltip group-hover:scale-100'>{text}</span> */}
    </div>
);

export default SideNav
